var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 74,
    viewBox: "0 0 78 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H56.0591V14.5827C54.0392 14.0116 51.9082 13.7059 49.7061 13.7059C36.841 13.7059 26.4118 24.1351 26.4118 37.0001C26.4118 49.8649 36.841 60.2941 49.7061 60.2941C51.9082 60.2941 54.0392 59.9888 56.0591 59.4174V73H1V1Z",
    fill: "#65CC48",
    stroke: "#65CC48",
    strokeWidth: 0.416667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7061 56.0588C54.2059 56.0588 58.3413 54.4991 61.602 51.8912L73.6079 63.9082C74.4345 64.7357 75.7754 64.7361 76.6025 63.9098C77.43 63.0831 77.4308 61.7423 76.6041 60.9148L64.5966 48.8966C67.2053 45.6359 68.7649 41.4998 68.7649 36.9998C68.7649 26.4738 60.2317 17.9409 49.7061 17.9409C39.18 17.9409 30.6471 26.4738 30.6471 36.9998C30.6471 47.5255 39.18 56.0588 49.7061 56.0588ZM49.7061 51.8233C57.8926 51.8233 64.5295 45.1865 64.5295 36.9998C64.5295 28.8129 57.8926 22.1762 49.7061 22.1762C41.5191 22.1762 34.8824 28.8129 34.8824 36.9998C34.8824 45.1865 41.5191 51.8233 49.7061 51.8233Z",
    fill: "#65CC48",
    stroke: "#65CC48",
    strokeWidth: 0.416667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingreviewIcon);
export default __webpack_public_path__ + "static/media/pendingreview-icon.81ed94c6a85137c27cdb61bab5332e4a.svg";
export { ForwardRef as ReactComponent };